<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">备案</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">新增接入</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">新增接入</div>
      </div>
      <div class="panel-body">
        <div class="alert-warn margin-bottom-20">
          请务必填写真实有效信息
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="labelPosition" label-width="230px" class="beian-ruleForm">
          <el-form-item label="网站备案号：" prop="baxh" :show-message="!formFocus.baxh">
            <el-input v-model="ruleForm.baxh" @focus="formFocus.baxh = true" @blur="formFocus.baxh = false"></el-input>
            <div class="icp-tip" v-show="formFocus.baxh">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请填写您网站的备案号，如：京ICP备*********号-1
              </div>
            </div>
          </el-form-item>
          <el-form-item label="ICP备案密码：" prop="icpmm" :show-message="!formFocus.icpmm">
            <el-input v-model="ruleForm.icpmm" @focus="formFocus.icpmm = true" @blur="formFocus.icpmm = false"></el-input>
            <div class="icp-tip" v-show="formFocus.icpmm">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请填写您的ICP备案密码
              </div>
            </div>
          </el-form-item>
          <el-form-item label="网站IP地址：" prop="ip" :show-message="!formFocus.ip">
            <el-input v-model="ruleForm.ip" @focus="formFocus.ip = true" @blur="formFocus.ip = false"></el-input>
            <div class="icp-tip" v-show="formFocus.ip">
              <i class="iconfont icon-i z-absolute"></i>
              <div class="icp-msg">
                <em class="hoticon-left"></em>
                请输入您的IP信息，多个IP用';'分割，如果IP信息为IP地址段，则起始IP和终止IP间用'-'分隔（如：111.67.0.100-111.67.0.102）。
              </div>
            </div>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input type="textarea" v-model="ruleForm.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="z-display-inlineBlock z-lineHeight-20">
              <xbutton font="下一步" type="orange" @XbuttonService="submitForm('ruleForm')"/>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import XfromInput from 'commons/XfromInput.vue'
  import XbeianCity from 'commons/XbeianCity.vue'
  import Xbutton from 'components/commons/Xbutton.vue'
  import beianService from 'business/beianService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  export default {
    data() {
      return {
        listLoading:false,
        dialogLoading:false,
        labelPosition: 'right',
        DISTRICTS:[],
        cityInfo: {
          province:'北京市',
          city:'市辖区',
          area:'东城区'
        },
        cityId:{
          provinceid: 0,
          cityid: 1,
          districtid: 1
        },
        ruleForm: {
          baxh:'',
          icpmm:'',
          ip:'',
          remark:''
        },
        rules: {
          baxh: [
            { required: true, message: '网站备案号格式不正确', trigger: 'blur' }
          ],
          icpmm: [
            { required: true, message: '请正确填写您的ICP备案密码！', trigger: 'blur' }
          ],
          ip: [
            { required: true, message: 'ip格式不正确', trigger: 'blur' }
          ]
        },
        formFocus: {
          baxh:false,
          icpmm:false,
          ip:false,
        }
      };
    },
    props:{
      hide:Boolean
    },
    components: {
      XfromInput,
      Xbutton,
      XbeianCity,
      XdialogLoading
    },
    mounted() {
      this.beianInfo()
    },
    computed: {

    },
    watch:{

    },
    methods:{
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      async beianInfo() {
        this.listLoading = true
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST','cmd=get_dm')
        if(state.code === '000' ) {
          this.DISTRICTS = vueData.qy
          this.listLoading = false
          this.ruleForm.dwxz = vueData.dwxz.map((item, index) => {
            return {
              value: item.id,
              label: item.mc
            }
          })
          this.zjlxArr = vueData.zjlx.map((item, index) => {
            return {
              value: item.id,
              label: item.mc,
              dwflid: item.dwflid
            }
          })
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async submit() {
        let data = 'cmd=jieru_add'+'&baxh=' + this.ruleForm.baxh + '&icpmm=' + this.ruleForm.icpmm + '&ip=' + this.ruleForm.ip
        this.dialogLoading = true
        let {vueData, state} = await beianService.transformToVue('beianInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {self.$router.push('/icpContent/'+vueData.taskid)}})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }
      }
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  .alert-warn {
    margin-bottom: 30px;
  }
  .beian-ruleForm .el-input,.el-select,.el-textarea {
    width: 374px;
  }
  .captcha .el-form-item__error {
    left: 380px;
  }

  .icp-msg {
    color: #4074e1;
    border: solid 1px #4074e1;
    background: #ecf1fc;
    border-radius: 3px;
    position: relative;
    margin-top: 10px;
    font-size: 12px;
    line-height: 18px;
    padding: 10px;
    width: 352px;
  }
  em{
    font-style: normal;
    font-weight: 500;
  }
  .icp-tip {
    position: absolute;
    left: 375px;
    top: 0;
    margin-left: 10px;
    width: 400px;
    line-height: 32px;
    font-size: 12px;
  }
  .icp-tip .icp-msg {
    margin: 0 0 0 30px;
    padding: 6px 10px;
    width: 300px;
  }
  .icp-tip span {
    padding-left: 26px;
  }
  .hoticon-left {
    position: absolute;
    top: 12px;
    left: -4px;
    background: url(../../assets/imgs/hoticon.png) no-repeat;
    background-position: 0 -5px;
    width: 4px;
    height: 6px;
  }
  .icon-i {
    color: #4074e1;
    padding-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/beian/beian8.vue